// app/javascript/controllers/landing_cta_controller.js
//
// Fires the Plausible custom event `LandingPageCTA` when a CTA on the
// /for-farmers landing page (campaign ad4) is tapped, tagged with the
// funnel position it sits at: {position: hero|pricing|how|final}.
//
// The CTA is a normal <a> that navigates to /signup?src=lp_ad4. Firing an
// analytics event and then immediately navigating can drop the beacon
// before Plausible's queued shim flushes it — the exact bug that showed
// 0 conversions for CompleteRegistration on 2026-07-14 (see
// docs/PLAUSIBLE.md). So we mirror the proven fix: defer the navigation
// until the beacon fires (callback) or a 500ms timeout, whichever comes
// first. If Plausible is absent (ad blocker), we do nothing and let the
// link navigate normally — tracking must never block a user's action.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  track(event) {
    const position = event.params.position
    const href = this.element.href

    // Fail open: no Plausible (or nowhere to go) → let the browser navigate.
    if (typeof plausible === "undefined" || !href) return

    event.preventDefault()

    let navigated = false
    const go = () => {
      if (navigated) return
      navigated = true
      window.location.href = href
    }

    try {
      plausible("LandingPageCTA", { props: { position }, callback: go })
      setTimeout(go, 500)
    } catch (e) {
      go()
    }
  }
}
